var _path;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAll(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.75 4.25C15.75 3.14543 14.8546 2.25 13.75 2.25H4.25C3.14543 2.25 2.25 3.14543 2.25 4.25V13.75C2.25 14.8546 3.14543 15.75 4.25 15.75H13.75C14.8546 15.75 15.75 14.8546 15.75 13.75V4.25ZM9.527 8.473H14.696V4.304C14.696 3.75172 14.2483 3.304 13.696 3.304H9.527V8.473ZM9.527 14.696H13.696C14.2483 14.696 14.696 14.2483 14.696 13.696V9.527H9.527V14.696ZM4.304 3.304C3.75172 3.304 3.304 3.75171 3.304 4.304V8.473H8.473V3.304H4.304ZM3.304 9.527V13.696C3.304 14.2483 3.75171 14.696 4.304 14.696H8.473V9.527H3.304Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAll);
export default __webpack_public_path__ + "static/media/all.226fd72a7065ed0d5953d9b2824ce00f.svg";
export { ForwardRef as ReactComponent };